import type { RefObject } from 'react';
import type { PopoverItemBaseProps } from '../../Popover/PopoverItem/PopoverItem';
import type { TopbarActionButtonProps } from './base/TopbarActionButton';

import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { LeaveIcon } from '../../../images/shapes';

import TopbarActionButton from './base/TopbarActionButton';

interface TopbarSaveAndLeaveButtonProps extends PopoverItemBaseProps {
  /**
   * Form id, if not provided form submission should be handled by onClick property
   */
  form?: string;
  /**
   * Reference to navigate on save property
   */
  navigateOnSave?: RefObject<boolean>;
}

const TopbarSaveAndLeaveButton = ({
  form,
  navigateOnSave: navigateOnSaveRef,
  ...props
}: TopbarSaveAndLeaveButtonProps & TopbarActionButtonProps) => {
  const { t } = useTranslation();

  const onClick = useCallback(() => {
    if (navigateOnSaveRef) navigateOnSaveRef.current = true;
  }, [navigateOnSaveRef]);

  return (
    <TopbarActionButton
      iconImage={<LeaveIcon className="w-3.5" />}
      label={t('Global.SaveAndLeave')}
      onClick={onClick}
      testIdSuffix="save-and-leave"
      additionalIconClasses="ml-1 w-3.5"
      {...(form ? { form, type: 'submit' } : {})}
      {...props}
    />
  );
};

export default TopbarSaveAndLeaveButton;
